import React, { Component } from 'react';
import { Link } from "react-router-dom";


import './dashNavigation.css';

import Estad from '../../../img/logoEstadisticas.png';
import History from '../../../img/logoHistory.png';
import Consumo from '../../../img/logoConsumo.png';
// import { async } from 'q';

class Navigation extends Component {

    constructor(props){
        super(props);
        this.state = {
            claseAplicar: 'itemHide',
        }
    }

    changeClassName = async (e) => {
        if(e.target.id){
            document.getElementById(e.target.id).classList.remove('itemHide');  
            document.getElementById(e.target.id).classList.add('itemShow'); 
        }
    }

    removeClassName = async (e) => {
        if(e.target.id){
            document.getElementById(e.target.id).classList.remove('itemShow');
            document.getElementById(e.target.id).classList.add('itemHide'); 
        }
    }

    render(){
        return(
            <div className='col s2 xl2 contenedorNavigation'>
                <div className='colNav'>
                    <ul className='itemsNav'>
                        <li className='itemHide' id={1} onMouseOver={this.changeClassName} onMouseOut={this.removeClassName}>
                            <Link to="/admin/dashboard/Estadisticas" onPointerMove={this.changeClassName} onMouseOut={this.removeClassName} id={1}>Estadísticas</Link>
                            <img src={Estad} alt='estadisticas'/>
                        </li>
                        <li className='itemHide' id={2} onPointerMove={this.changeClassName} onMouseOut={this.removeClassName}>
                            <Link to="/admin/dashboard/Historial" onPointerMove={this.changeClassName} onMouseOut={this.removeClassName} id={2}>Historial de chats</Link>
                            <img src={History} alt='history'/>
                        </li>
                        <li className='itemHide' id={3} onPointerMove={this.changeClassName} onMouseOut={this.removeClassName}>
                            <Link to="/admin/dashboard/Consumo" onPointerMove={this.changeClassName} onMouseOut={this.removeClassName} id={3}>Consumo</Link>
                            <img src={Consumo} alt='consumo'/>
                        </li>
                    </ul>
                </div>
            </div>
        );
    }
}

export default Navigation;